import AppContextProvider from 'context/app';
import LocalisationWrapper from 'i18n/localisation-wrapper';
import AppRouter from 'router';

const App = () => {
  return (
    <LocalisationWrapper>
      <AppContextProvider>
        <AppRouter />
      </AppContextProvider>
    </LocalisationWrapper>
  );
};

export default App;
